export enum UserType {
  Employee = 'employee',
  Customer = 'customer',
  User = 'user',
}

export interface UserAttributeType {
  Name: string;
  Value: string;
}
export interface MFAOptionType {
  DeliveryMedium?: string;
  AttributeName?: string;
}
export declare type UserStatusType =
  | 'UNCONFIRMED'
  | 'CONFIRMED'
  | 'ARCHIVED'
  | 'COMPROMISED'
  | 'UNKNOWN'
  | 'RESET_REQUIRED'
  | 'FORCE_CHANGE_PASSWORD';
export declare type UserMFASettingListType = 'SMS_MFA' | 'SOFTWARE_TOKEN_MFA';
export declare type PreferredMfaSettingType = 'SOFTWARE_TOKEN_MFA' | 'SMS_MFA';
export interface AdminGetUserResponseCognitoType {
  Username: string;
  UserAttributes?: unknown;
  UserCreateDate?: Date;
  UserLastModifiedDate?: Date;
  Enabled: boolean;
  UserStatus: UserStatusType;
  PreferredMfaSetting?: PreferredMfaSettingType;
}
export interface AdminGetUserOnlyResponseCognitoType {
  Username: string;
  Enabled: boolean;
  UserStatus: UserStatusType;
  ActivationStatus: string;
}

export interface CodeDeliveryDetailsType {
  AttributeName: string;
  DeliveryMedium: string;
  Destination: string;
}

export interface SignUpResponseCognitoType {
  UserConfirmed: boolean;
  UserSub: string;
  CodeDeliveryDetails: CodeDeliveryDetailsType;
}
export type ChallengeParametersType = { [key: string]: string };

export type ChallengeNameType =
  | 'SMS_MFA'
  | 'SOFTWARE_TOKEN_MFA'
  | 'SELECT_MFA_TYPE'
  | 'MFA_SETUP'
  | 'PASSWORD_VERIFIER'
  | 'CUSTOM_CHALLENGE'
  | 'DEVICE_SRP_AUTH'
  | 'DEVICE_PASSWORD_VERIFIER'
  | 'ADMIN_NO_SRP_AUTH'
  | 'NEW_PASSWORD_REQUIRED'
  | string;
export type DeviceKeyType = string;

export interface NewDeviceMetadataType {
  DeviceKey?: DeviceKeyType;
  DeviceGroupKey?: string;
}
export interface AuthenticationResultType {
  AccessToken?: string;
  ExpiresIn?: number;
  IdToken?: string;
  RefreshToken?: string;
  TokenType?: string;
  NewDeviceMetadata?: NewDeviceMetadataType;
}
export interface InitiateAuthResponseCognitoType {
  ChallengeName?: ChallengeNameType;
  Session?: string;
  ChallengeParameters?: ChallengeParametersType;
  AuthenticationResult?: AuthenticationResultType;
}
export interface RespondToAuthChallengeResponseCognitoType {
  ChallengeName: string;
  Session: string;
  ChallengeParameters?: ChallengeParametersType;
  AuthenticationResult: AuthenticationResultType;
}
export interface UserSignUpResponseWithCognitoType {
  creationStatus: SignUpResponseCognitoType;
  username: string;
}
export interface GoogleAuthTokenPayloadType {
  accessToken: string;
  idToken: string;
  refreshToken: string;
}
export interface UploadFileResponseType {
  imgUrl: string;
}

export type AllowedFeaturesType = { [key: string]: AllowedFeaturesData };

export interface AllowedFeaturesData {
  approvalNeeded: boolean;
  action: string[];
}

export enum UserTypes {
  EMPLOYEE = 'employee',
  CUSTOMER = 'customer',
  USER = 'user',
}
export const permissionsIds = {
  Create: 1,
  Edit: 2,
  Delete: 3,
  Read: 4,
  Visible: 5,
};
